import api from './api';

// Service du module « Avis Google » (Google Business Profile).
const gmbApi = {
  // Connexion OAuth (super-admin)
  authStatus: () => api.get('/gmb/auth/status'),
  authUrl: () => api.get('/gmb/auth/url'),

  // Fiches (locations)
  refreshLocations: () => api.post('/gmb/locations/refresh'),
  getLocations: () => api.get('/gmb/locations'),
  getLocationsOverview: () => api.get('/gmb/locations/overview'),
  getLocationDetails: (id) => api.get(`/gmb/locations/${id}/details`),
  updateLocationDetails: (id, data) => api.patch(`/gmb/locations/${id}/details`, data),
  updateLocation: (id, data) => api.patch(`/gmb/locations/${id}`, data),

  // Prompts IA par fiche (super-admin)
  getPromptRules: () => api.get('/gmb/prompt-rules'),
  refinePrompt: (id, human) => api.post(`/gmb/locations/${id}/prompt/refine`, { human }),
  savePrompt: (id, data) => api.patch(`/gmb/locations/${id}/prompt`, data),

  // Tableau de bord (agrégats : notes, évolution, répartition, classement)
  getStats: (params = {}) => api.get('/gmb/stats', { params }),

  // Avis
  getReviews: (params = {}) => api.get('/gmb/reviews', { params }),
  draftReply: (id) => api.post(`/gmb/reviews/${id}/draft`),
  reply: (id, comment) => api.post(`/gmb/reviews/${id}/reply`, { comment }),
  markRead: (id) => api.post(`/gmb/reviews/${id}/read`),
  deleteReview: (id) => api.delete(`/gmb/reviews/${id}`),
  bulkDelete: (ids) => api.delete('/gmb/reviews', { data: { ids } }),

  // Synchronisation manuelle
  sync: () => api.post('/gmb/sync'),
};

export default gmbApi;
